import request from '@/utils/request';
const path = 'channel';

/**
 * 批量获取渠道详情接口
 * @param {object} params 请求参数
 * @returns {Promise<object>}
 */
export function getChannelDetailsApi(params) {
  return request({
    url: `${path}/details`,
    method: 'GET',
    params,
  });
}
